import contentTitle from '@/utils/contentTitle'
import axios from 'axios'
import { createReadPool } from './readPool'



// const path = 'https://apicdn.zuopin.cloud/api'

const path = '/api'

//创建新的axios实例，
const service = axios.create({
    baseURL: path
    // timeout: 1000,

})

// 请求拦截器
service.interceptors.request.use(config => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = JSON.stringify(config.data);

    const identity = config.accountScope;
    delete config.accountScope;
    if ((window.localStorage.getItem('access_token') || '') !== identity) return Promise.reject(new Error('account_changed'));
    if (identity) {
        var token = JSON.parse(identity);
        config.headers = {
            'Content-Type': 'application/json',
            'X-Content-Review': '1',
            'Authorization':'bearer ' + token
        }

    }else{
        config.headers = {
            'Content-Type': 'application/json',
            'X-Content-Review': '1'
        }
    }
    
   

    return config
}, error => {
    return Promise.reject(error)
})

//响应兰截器
service.interceptors.response.use(response => {
    response.data = contentTitle.normalize(response.data)
    //接收到响应数据并成功后的一些共有的处理，关闭loading等

    return response
}, error => {
    /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
        // 1.公共错误处理
        // 2.根据响应码具体处理
        console.log(error.response.data.status_code)
        switch (error.response.data.status_code) {
            case 400:
                error.message = '错误请求'
                break;
            case 401:
                error.message = '未授权，请重新登录'
                // window.location.href = "https://zuopin.cloud/#/"
                // window.location.href = "https://zuopin.cloud/"
                break;
            case 403:
                error.message = '拒绝访问'
                break;
            case 404:
                error.message = '请求错误,未找到该资源'
                // window.location.href = "/NotFound"
                break;
            case 405:
                error.message = '请求方法未允许'
                break;
            case 408:
                error.message = '请求超时'
                break;
            case 500:
                error.message = '服务器端出错'
                break;
            case 501:
                error.message = '网络未实现'
                break;
            case 502:
                error.message = '网络错误'
                break;
            case 503:
                error.message = '服务不可用'
                break;
            case 504:
                error.message = '网络超时'
                break;
            case 505:
                error.message = 'http版本不支持该请求'
                break;
            default:
                error.message = `连接错误${error.response.status}`
        }
    } else {
        // 超时处理
        // if (JSON.stringify(error).includes('timeout')) {
        //     Message.error('服务器响应超时，请刷新当前页')
        // }
        // error.message('连接服务器失败')
    }

    // Message.error(error.message)
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response)
})

const read = createReadPool()
export default function request(config) {
    const identity = window.localStorage.getItem('access_token') || ''
    return read(config, identity, value => service({ ...value, accountScope: identity })).then(response => {
        if ((window.localStorage.getItem('access_token') || '') !== identity) throw new Error('account_changed')
        return response
    })
}